export default {
  classTrans: 'Transfer Class',
  classTransDiff: 'Transfer Classes with different price',
  actuallyPrice: 'Course fee (target class)',
  remainingFee: 'Remaining course fee (current class)',
  refundTotal: 'Refund Total',
}
